import { clone } from '@jkhy/frontend-utils/functions';
import { IpRestrictionAddressModelDto as BoIpRestrictionAddressModelDto } from '@treasury/api/bo';
import { IpRestrictionAddressModelDto as ConsumerIpRestrictionAddressModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';

const nullBoIpRestrictionAddress: BoIpRestrictionAddressModelDto = {
    id: 0,
    octet1: 0,
    octet2: 0,
    octet3: 0,
    octet4: 0,
};

export class IpRestrictionAddress extends DomainEntity<
    BoIpRestrictionAddressModelDto | ConsumerIpRestrictionAddressModelDto
> {
    constructor(dto = clone(nullBoIpRestrictionAddress)) {
        super(dto);
    }

    public createDefault(): this {
        return new IpRestrictionAddress(clone(nullBoIpRestrictionAddress)) as this;
    }

    public get id() {
        return this.dto.id;
    }

    public get octets(): [number, number, number | undefined, number | undefined] {
        return [
            this.dto.octet1 ?? 0,
            this.dto.octet2 ?? 0,
            this.dto.octet3 ?? 0,
            this.dto.octet4 ?? 0,
        ];
    }

    public set octet1(value: number) {
        this.dto.octet1 = value;
    }

    public set octet2(value: number) {
        this.dto.octet2 = value;
    }

    public set octet3(value: number | undefined) {
        this.dto.octet3 = value;
    }

    public set octet4(value: number | undefined) {
        this.dto.octet4 = value;
    }

    public get ipAddress() {
        if (
            this.dto.octet1 === 0 &&
            this.dto.octet2 === 0 &&
            this.dto.octet3 === 0 &&
            this.dto.octet4 === 0
        ) {
            return '';
        }
        return `${this.dto.octet1}.${this.dto.octet2}.${this.dto.octet3}.${this.dto.octet4}`;
    }

    public set ipAddress(value: string) {
        const [octet1, octet2, octet3, octet4] = value.split('.');
        this.dto.octet1 = parseInt(octet1);
        this.dto.octet2 = parseInt(octet2);
        this.dto.octet3 = parseInt(octet3);
        this.dto.octet4 = parseInt(octet4);
    }

    public get name() {
        return this.dto.name ?? '';
    }

    public set name(value: string) {
        this.dto.name = value;
    }

    public toDto(): BoIpRestrictionAddressModelDto | ConsumerIpRestrictionAddressModelDto {
        return clone(this.dto);
    }
}
